import { Config } from "../config";
import { useApi } from "../composables/useApi";

export const useApesStorageApi = useApi((args) => ({
  ...(args || {}),
  baseURL: Config.apeStorageUrl,
}));
